import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const formRowStyle = css`
  padding: 0;
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  min-height: ${theme.spacing(9)};
  margin-right: 0;
`;

export const titleContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(0.75, 0, 0.75, 0)};
`;

export const inputContainerStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing(1)};
  flex-basis: 40%;
  margin: ${theme.spacing(0, 0, 0, 1)};
`;

export const baseFieldStyle = css`
  height: ${theme.spacing(4)};
`;

export const dateFieldStyle = css`
  padding: ${theme.spacing(0, 1)};
`;
